import { AxiosInstance } from 'axios';

import * as common from '../../../../../../typings/api/skymap/rest/v0/.common';
import * as types from '../../../../../../typings/api/skymap/rest/v0/orthotile';

export class OrthoTileService implements types.Handlers {
  private serviceEndpoint = '/orthotiles';

  constructor(private axios: AxiosInstance) {}

  async createOrthotile({
    body,
  }: types.CreateOrthotileParameters): Promise<types.CreateOrthotileResponse> {
    return (
      await this.axios.post(`${this.serviceEndpoint}/create`, {
        ...body,
      })
    ).data;
  }
  async delete({ body }: types.DeleteParameters): Promise<types.DeleteOrthotileResponse> {
    return (
      await this.axios.post(`${this.serviceEndpoint}/delete`, {
        ...body,
      })
    ).data;
  }
  async fetchById({ body }: types.FetchByIdParameters): Promise<types.FetchByIdResponse> {
    return (
      await this.axios.post(`${this.serviceEndpoint}/fetchById`, {
        ...body,
      })
    ).data;
  }

  async fetchTile({ body }: types.FetchTileParameters): Promise<types.FetchTileResponse> {
    return (await this.axios.post(`${this.serviceEndpoint}/fetchTile`, body)).data;
  }

  async fetchSignRequestParameters({
    path,
  }: types.FetchSignRequestParametersParameters): Promise<common.SignedRequestResponse> {
    return (await this.axios.get(`${this.serviceEndpoint}/${path.orthoTileId}/signed-request`))
      .data;
  }
}
